import { SafeHtml } from '@shared/ui'
import './learning-template-question-content.css'

export function LearningTemplateQuestionContent({
  className,
  content,
  questions,
}: {
  readonly className?: string
  readonly content?: string | null
  readonly questions?: readonly string[]
}) {
  const entries = questions ?? (content ? [content] : [])

  if (entries.length === 0) {
    return null
  }

  const rootClassName = [
    'learningTemplateQuestionContent',
    questions ? 'learningTemplateQuestionContentList' : null,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={rootClassName}>
      {entries.map((entry, index) => (
        <SafeHtml
          className="learningTemplateQuestionContentItem legacySelfStudyAuthoredHtml"
          html={entry}
          key={`${index}-${entry}`}
        />
      ))}
    </div>
  )
}
